export const EMAIL_ERROR = 'Please enter a valid email';

export const PASSWORD_ERROR = 'Please enter a valid password';

export const TERMS_CONDITIONS_ERROR = 'You must please read and accept the "Terms of Use", "Privacy Policy" and "End User Agreement" before proceeding';
